import React from "react";
import { Navigate, useRoutes } from "react-router-dom";

import DashboardLayout from "Layouts/Admin/DashboardLayout";
import Administrator from "Modules/Admin/Administrator";
import AdminDetails from "Modules/Admin/Administrator/Components/AdminDetails/AdminDetails";
import ViewRole from "Modules/Admin/Administrator/Components/ViewRole/ViewRole";
import Dashboard from "Modules/Admin/Dashboard";
import Login from "Modules/Auth/Login";
import OTP from "Modules/Auth/Login/OTP";
import GoogleAuth from "Modules/Auth/Login/GoogleAuth";
import VerifySecurityCode from "Modules/Auth/Login/VerifySecurityCode";
import UnderDevelopment from "Modules/Admin/UnderDevelopment";
import ResetPassword from "Modules/Auth/ResetPassword";
import Profile from "Modules/Admin/Profile";
import User from "Modules/Admin/User";
import ViewUser from "Modules/Admin/User/ViewUser/ViewUser";
import ViewPortfolio from "Modules/Admin/User/ViewUser/ViewPortfolio/ViewPortfolio";
import ViewOpportunity from "Modules/Admin/User/ViewUser/ViewOpportunity/ViewOpportunity";
import ViewCoursePurchase from "Modules/Admin/User/ViewUser/ViewCoursePurchase/ViewCoursePurchase";
import ViewMarketplace from "Modules/Admin/User/ViewUser/ViewMarketplace/ViewMarketplace";
import ViewUserSubscription from "Modules/Admin/User/ViewUser/ViewUserSubscription/ViewUserSubscription";
import Course from "Modules/Admin/Course";
import ViewCourse from "Modules/Admin/Course/ViewCourse/ViewCourse";
import ViewInquiry from "Modules/Admin/Course/ViewInquiry/ViewInquiry";
import Subscription from "Modules/Admin/Subscription";

export default function Router() {
  const token = localStorage.getItem("auth-token");
  const isAdmin = !!token;
  const isSuperAdmin = false;

  return useRoutes([
    {
      path: "/admin",
      element:
        isAdmin || isSuperAdmin ? (
          <DashboardLayout />
        ) : (
          <Navigate to="/login" replace />
        ),
      children: [
        { path: "", element: <Navigate to="/admin/dashboard" replace /> },
        { path: "dashboard", element: <Dashboard /> },
        { path: "administrator", element: <Administrator /> },
        { path: "administrator/details", element: <AdminDetails /> },
        { path: "administrator/view-role", element: <ViewRole /> },
        { path: "user", element: <User /> },
        { path: "user/view-user", element: <ViewUser /> },
        { path: "user/view-portfolio", element: <ViewPortfolio /> },
        { path: "user/view-opportunity", element: <ViewOpportunity /> },
        { path: "user/view-course-purchase", element: <ViewCoursePurchase /> },
        { path: "user/view-marketplace", element: <ViewMarketplace /> },
        { path: "user/view-user-subscription", element: <ViewUserSubscription /> },
        { path: "course", element: <Course /> },
        { path: "course/view-course", element: <ViewCourse /> },
        { path: "course/view-inquiry", element: <ViewInquiry /> },
        { path: "subscription", element: <Subscription /> },
        { path: "profile", element: <Profile /> },
        { path: "*", element: <UnderDevelopment /> },
      ],
    },
    {
      path: "/login",
      element:
        !isAdmin && !isSuperAdmin ? (
          <Login />
        ) : (
          <Navigate to="/admin" replace />
        ),
    },
    {
      path: "/otp",
      element:
        !isAdmin && !isSuperAdmin ? <OTP /> : <Navigate to="/admin" replace />,
    },
    {
      path: "/google-auth",
      element:
        !isAdmin && !isSuperAdmin ? (
          <GoogleAuth />
        ) : (
          <Navigate to="/admin" replace />
        ),
    },
    {
      path: "/verify-security-code",
      element:
        !isAdmin && !isSuperAdmin ? (
          <VerifySecurityCode />
        ) : (
          <Navigate to="/admin" replace />
        ),
    },
    {
      path: "/reset-password",
      element:
        !isAdmin && !isSuperAdmin ? (
          <ResetPassword />
        ) : (
          <Navigate to="/admin" replace />
        ),
    },
    { path: "/", element: <Navigate to="/admin/dashboard" replace /> },
  ]);
}
